import { Container, Heading, SimpleGrid, Text } from "@chakra-ui/react";
import React from "react";

import SkillsCard from "./SkillsCard";

import {
  SiNodedotjs,
  SiJavascript,
  SiExpress,
  SiReact,
  SiPhp,
  SiLaravel,
  SiTailwindcss,
  SiFirebase,
  SiMongodb,
  SiMysql,
} from "react-icons/si";

import { Link } from "react-router-dom";

const SkillsOverView = () => {
  return (
    <Container maxW={"container.lg"}>
      <Heading
        size={"md"}
        className="text-center text-3xl uppercase mt-12 mb-2"
      >
        What I Know !
      </Heading>

      <hr className="mb-6 mx-60 border-teal-400" />

      <SimpleGrid columns={[1, 2, 3, 4, 5]} spacing="2">
        <SkillsCard
          bg={"bg-green-900 hover:bg-green-500"}
          title="Javascript"
          text={
            "JavaScript is a high-level, often just-in-time compiled language."
          }
          icon={<SiJavascript />}
        />

        <SkillsCard
          bg={"bg-rose-900 hover:bg-rose-500"}
          title="React"
          text={"The Most Popular Javascript Library"}
          icon={<SiReact />}
        />

        <SkillsCard
          bg={"bg-teal-900 hover:bg-teal-500"}
          title="Node Js"
          text={"As an asynchronous event-driven JavaScript runtime."}
          icon={<SiNodedotjs />}
        />

        <SkillsCard
          bg={"bg-green-900 hover:bg-green-500"}
          title="Express Js"
          text={"Most Popular Node js Framework"}
          icon={<SiExpress />}
        />
        <SkillsCard
          bg={"bg-fuchsia-900 hover:bg-fuchsia-500"}
          title="Tailwind Css"
          text={"The Most Popular Css Framework."}
          icon={<SiTailwindcss />}
        />
        <SkillsCard
          bg={"bg-indigo-900 hover:bg-indigo-500"}
          title="PHP"
          text={"PHP is an open-source server-side scripting language."}
          icon={<SiPhp />}
        />
        <SkillsCard
          bg={"bg-lime-900 hover:bg-lime-500"}
          title="Laravel"
          text={"Most Popular PHP Framework"}
          icon={<SiLaravel />}
        />

        <SkillsCard
          bg={"bg-sky-500 hover:bg-sky-500"}
          title="MySQL"
          text={"MySQL is a relational database management system (RDBMS)."}
          icon={<SiMysql />}
        />
        <SkillsCard
          bg={"bg-blue-900 hover:bg-blue-500"}
          title="Firebase"
          text={
            "The Firebase Realtime Database is a cloud-hosted NoSQL database."
          }
          icon={<SiFirebase />}
        />
        <SkillsCard
          bg={"bg-teal-900 hover:bg-teal-500"}
          title="MongoDB"
          text={"MongoDB is a non-relational document database."}
          icon={<SiMongodb />}
        />
      </SimpleGrid>
      <Text
        fontSize={"sm"}
        className="rounded py-3 text-2xl text-center my-3 bg-teal-400 dark:bg-red-500"
      >
        Please Visit the skills sections to know .
        <Link className="underline" to="/skills#root">
          all the skills i have got &rarr;{" "}
        </Link>
      </Text>
    </Container>
  );
};

export default SkillsOverView;
